import { computed } from "vue";
import { useFlag } from "./useFlag";
import { useAuthenticationStore } from "@/store/authentication.store";

export const useIsSEGCheckboxAvailable = () => {
  const { isFeatureAvailable } = useFlag("SEG_CHECKBOX");

  const authStore = useAuthenticationStore();

  const authUser = computed(() => authStore.authUser);
  const email = computed(() => authUser.value?.email as string | undefined);

  const isSEGCheckboxAvailable = computed(
    () =>
      isFeatureAvailable.value ||
      ["admin@titanhq.com", "chinchey@titanhq.com"].includes(
        email.value as string,
      ),
  );

  return { isSEGCheckboxAvailable };
};
